<template>
    <b-modal id="importar-licitacao-modal" size="lg" centered header-bg-variant="secondary" header-text-variant="light"
        title="Importar licitações" hide-footer @hidden="$emit('fecharModal')" :no-close-on-esc="isLoading"
        :no-close-on-backdrop="isLoading" :hide-header-close="isLoading">
        <b-row>
            <b-col cols="12" sm="9">
                <b-form-group id="arquivo-input-group" label="" label-for="input-arquivo" label-cols="auto">
                    <b-form-file v-model="arquivo" placeholder="Escolha o arquivo XML (zipado)" :disabled="isLoading"
                        drop-placeholder="Solte o arquivo aqui" browse-text="..." accept=".zip"></b-form-file>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="3" class="text-center">
                <b-button @click="enviarArquivo" :disabled="isLoading || !arquivo">
                    <b-spinner small v-if="isLoading" class="mr-1"></b-spinner>
                    <font-awesome-icon v-else icon="cloud-upload" />
                    Enviar
                </b-button>
            </b-col>
        </b-row>
        <b-row v-if="retornoImportacoes" class="mt-1 px-2">
            <b-card no-body :header-bg-variant="retornoImportacoes.corSituacao()"
                :border-variant="retornoImportacoes.corSituacao()" header-text-variant="white"
                :header="`Importações realizadas para ${retornoImportacoes.nomeArquivo}`">
                <div id="importcardwrapper" class="p-3">
                    <CardFiltrosBusca v-if="retornoImportacoes.erros"
                        :titulo="`Erros encontrados (${retornoImportacoes.erros.length})`" border="danger" class="mb-2">
                        <ul>
                            <li v-for="err in retornoImportacoes.erros.slice(0, 4)" :key="err">{{ err }}</li>
                        </ul>
                        <div class="d-flex justify-content-center my-2">
                            <btn-download :fazerDownload="baixarRelatorioErros" texto="Relatório de erros" botao />
                        </div>
                    </CardFiltrosBusca>
                    <b-card v-if="retornoImportacoes.houveImportacao()" no-body border-variant="success"
                        header="Licitações que foram importadas">
                        <b-alert v-if="retornoImportacoes.houvePendencias()" show variant="warning">Houve licitações importadas com pendências. Baixar relatório <btn-download :fazerDownload="baixarRelatorioPendencias" texto=""/></b-alert>
                        <b-table :fields="fields" hover no-border-collapse striped
                            :items="retornoImportacoes.licitacoesImportadas" stacked="md">
                        </b-table>
                    </b-card>
                    <b-card v-if="retornoImportacoes.houveNaoImportacao()" no-body border-variant="danger"
                        header="Licitações que NÃO foram importadas">
                        <b-table :fields="fields" hover no-border-collapse striped
                            :items="retornoImportacoes.licitacoesNaoImportadas" stacked="md">
                        </b-table>
                    </b-card>
                </div>
            </b-card>
        </b-row>
    </b-modal>
</template>

<script lang="ts">
import ldiService from '@/services/licitacoes/ldiService'
import { fieldsImportacao } from '@/types/licitacoes/ldi/fields-licitacoes';
import { RetornoImportarLicitacoes } from '@/types/licitacoes/ldi/retornos/retorno-importar-licitacoes'
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import BtnDownload from '@/components/shared/btn-download.vue'
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';

const CompProps = Vue.extend({
    name: 'ModalImportarLicitacao',
    components: { BtnDownload, CardFiltrosBusca },
    props: {}
})

@Component
export default class ModalImportarLicitacao extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsImportacao
    arquivo: File | null = null
    isLoading = false
    retornoImportacoes: RetornoImportarLicitacoes | null = null

    async mounted() {
        this.$bvModal.show("importar-licitacao-modal");
    }

    async enviarArquivo() {
        try {
            this.isLoading = true
            if (!this.arquivo) return this.$toast.error('Arquivo não selecionado')
            const response = await ldiService.importarLicitacoes(this.arquivo)
            this.retornoImportacoes = response
            this.retornoImportacoes.nomeArquivo = this.arquivo.name
            this.arquivo = null
            // console.log('modalimportarlicitacao.enviarArquivo', response)
            if (this.retornoImportacoes.houveImportacao())
                this.$emit('atualizarLicitacoes', this.retornoImportacoes.licitacoesImportadas)
        } catch (error: any) {
            this.tratarError(error)
        } finally {
            this.isLoading = false
        }
    }

    async baixarRelatorioErros() {
        if (this.retornoImportacoes) {
            try {
                const response = await ldiService.baixarRelatorioInconsistencias(this.retornoImportacoes)
                this.download('rel-erros-ldi.pdf', response)
            } catch (error: any) {
                this.tratarError(error)
            }
        }
    }

    async baixarRelatorioPendencias() {
        if (this.retornoImportacoes) {
            try {
                const response = await ldiService.baixarRelatorioPendencias(this.retornoImportacoes)
                this.download('rel-pendencias-ldi.pdf', response)
            } catch (error: any) {
                this.tratarError(error)
            }
        }
    }
}
</script>

<style scoped>
:deep(label.custom-file-label::after) {
    display: none;
}
</style>